(() => {
  const $ = (selector, root = document) => root.querySelector(selector);
  const $$ = (selector, root = document) => [...root.querySelectorAll(selector)];

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-ticker-toggle]');
    if (!button) return;
    const strip = button.closest('[data-ticker]');
    if (!strip) return;
    const paused = strip.dataset.paused !== 'true';
    strip.dataset.paused = String(paused);
    button.setAttribute('aria-pressed', String(paused));
    button.setAttribute('aria-label', `${paused ? 'Resume' : 'Pause'} ${button.dataset.tickerLabel}`);
    button.textContent = paused ? '▶' : 'Ⅱ';
  });

  document.addEventListener('shopify:section:load', (event) => {
    window.thornvellaInitMarquee?.($('[data-message-marquee]', event.target));
    initThemeCarousels(event.target);
  });

  const initializedThemeCarousels = new WeakSet();
  const initThemeCarousels = (scope = document) => {
    const carousels = scope.matches?.('[data-theme-carousel]') ? [scope] : $$('[data-theme-carousel]', scope);
    carousels.forEach((carousel) => {
      if (initializedThemeCarousels.has(carousel)) return;
      const viewport = $('[data-theme-viewport]', carousel);
      const track = $('[data-theme-track]', carousel);
      const previous = $('[data-theme-prev]', carousel);
      const next = $('[data-theme-next]', carousel);
      if (!viewport || !track || !previous || !next) return;
      const cards = [...track.children].filter((item) => item.classList.contains('theme-collections__card'));
      if (!cards.length) return;
      initializedThemeCarousels.add(carousel);

      const maxScroll = () => Math.max(0, viewport.scrollWidth - viewport.clientWidth);
      const updateControls = () => {
        const atStart = viewport.scrollLeft <= 2;
        previous.hidden = atStart;
        previous.disabled = atStart;
        next.disabled = viewport.scrollLeft >= maxScroll() - 2;
      };
      const moveOneCard = (direction) => {
        const step = cards[1]
          ? cards[1].getBoundingClientRect().left - cards[0].getBoundingClientRect().left
          : cards[0].getBoundingClientRect().width;
        if (step <= 0) return;
        const index = Math.round(viewport.scrollLeft / step) + direction;
        const left = Math.min(maxScroll(), Math.max(0, index * step));
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        viewport.scrollTo({ left, behavior: reducedMotion ? 'auto' : 'smooth' });
      };

      previous.addEventListener('click', () => moveOneCard(-1));
      next.addEventListener('click', () => moveOneCard(1));
      viewport.addEventListener('scroll', updateControls, { passive: true });
      if (window.ResizeObserver) new ResizeObserver(updateControls).observe(viewport);
      else window.addEventListener('resize', updateControls);
      requestAnimationFrame(updateControls);
    });
  };
  initThemeCarousels();

  const menuButton = $('[data-menu-toggle]');
  const mobileMenu = $('#MobileMenu');
  menuButton?.addEventListener('click', () => {
    const open = mobileMenu.hasAttribute('hidden');
    mobileMenu.toggleAttribute('hidden', !open);
    menuButton.setAttribute('aria-expanded', String(open));
    menuButton.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
  });

  const searchOverlay = $('#SearchOverlay');
  const searchButton = $('[data-search-open]');
  const closeSearch = () => {
    if (!searchOverlay) return;
    searchOverlay.hidden = true;
    searchButton?.setAttribute('aria-expanded', 'false');
  };
  searchButton?.addEventListener('click', () => {
    const open = searchOverlay.hidden;
    searchOverlay.hidden = !open;
    searchButton.setAttribute('aria-expanded', String(open));
    if (open) $('#HeaderSearch')?.focus();
  });
  $('[data-search-close]')?.addEventListener('click', closeSearch);

  $$('[data-auto-submit]').forEach((select) => {
    select.addEventListener('change', () => select.form?.requestSubmit());
  });

  const wishlistKey = 'thornvella-wishlist-v1';
  const drawer = $('#WishlistDrawer');
  const drawerItems = $('[data-wishlist-items]');
  const drawerTrigger = $('[data-wishlist-open]');
  let wishlist = [];
  try {
    const stored = JSON.parse(localStorage.getItem(wishlistKey) || '[]');
    if (Array.isArray(stored)) wishlist = stored.filter((item) => item && typeof item.handle === 'string').slice(0, 50);
  } catch (_) { wishlist = []; }

  const saveWishlist = () => {
    try { localStorage.setItem(wishlistKey, JSON.stringify(wishlist)); } catch (_) {}
  };
  const updateWishlistButtons = () => {
    const handles = new Set(wishlist.map((item) => item.handle));
    $$('[data-wishlist-toggle]').forEach((button) => {
      const saved = handles.has(button.dataset.productHandle);
      button.setAttribute('aria-pressed', String(saved));
      button.setAttribute('aria-label', (saved ? 'Remove ' : 'Save ') + (button.dataset.productTitle || 'product') + (saved ? ' from wishlist' : ' to wishlist'));
    });
    $$('[data-wishlist-count]').forEach((badge) => {
      badge.textContent = String(wishlist.length);
      badge.hidden = wishlist.length === 0;
    });
  };
  const renderWishlist = () => {
    if (!drawerItems) return;
    drawerItems.replaceChildren();
    if (wishlist.length === 0) {
      const empty = document.createElement('p');
      empty.className = 'wishlist-drawer__note';
      empty.textContent = 'No saved pieces yet. Tap the heart on any piece to keep it close.';
      drawerItems.append(empty);
      return;
    }
    wishlist.forEach((item) => {
      const row = document.createElement('div');
      row.className = 'wishlist-item';
      const imageLink = document.createElement('a');
      imageLink.href = item.url || '/collections/all';
      if (item.image) {
        const image = document.createElement('img');
        image.src = item.image;
        image.alt = '';
        image.loading = 'lazy';
        imageLink.append(image);
      }
      const content = document.createElement('div');
      const title = document.createElement('h3');
      const titleLink = document.createElement('a');
      titleLink.href = item.url || '/collections/all';
      titleLink.textContent = item.title || 'Saved piece';
      title.append(titleLink);
      const price = document.createElement('p');
      price.textContent = item.price || '';
      const remove = document.createElement('button');
      remove.type = 'button';
      remove.textContent = 'Remove';
      remove.addEventListener('click', () => {
        wishlist = wishlist.filter((saved) => saved.handle !== item.handle);
        saveWishlist();
        updateWishlistButtons();
        renderWishlist();
      });
      content.append(title, price, remove);
      row.append(imageLink, content);
      drawerItems.append(row);
    });
  };
  const closeWishlist = () => {
    if (!drawer) return;
    drawer.hidden = true;
    document.body.classList.remove('no-scroll');
    drawerTrigger?.setAttribute('aria-expanded', 'false');
    drawerTrigger?.focus();
  };
  drawerTrigger?.addEventListener('click', () => {
    if (!drawer) return;
    renderWishlist();
    drawer.hidden = false;
    document.body.classList.add('no-scroll');
    drawerTrigger.setAttribute('aria-expanded', 'true');
    $('button[data-wishlist-close]', drawer)?.focus();
  });
  $$('[data-wishlist-close]').forEach((button) => button.addEventListener('click', closeWishlist));
  document.addEventListener('click', (event) => {
      const button = event.target.closest('[data-wishlist-toggle]');
      if (!button) return;
      const handle = button.dataset.productHandle;
      if (!handle) return;
      const existing = wishlist.findIndex((item) => item.handle === handle);
      if (existing >= 0) {
        wishlist.splice(existing, 1);
      } else {
        wishlist.unshift({
          handle,
          title: button.dataset.productTitle,
          url: button.dataset.productUrl,
          image: button.dataset.productImage,
          price: button.dataset.productPrice
        });
      }
      wishlist = wishlist.slice(0, 50);
      saveWishlist();
      updateWishlistButtons();
      renderWishlist();
  });
  document.addEventListener('thornvella:products-updated', updateWishlistButtons);
  updateWishlistButtons();

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    closeSearch();
    if (drawer && !drawer.hidden) closeWishlist();
    if (mobileMenu && !mobileMenu.hidden) {
      mobileMenu.hidden = true;
      menuButton?.setAttribute('aria-expanded', 'false');
    }
  });

  const quantity = $('#ProductQuantity');
  $('[data-quantity-minus]')?.addEventListener('click', () => {
    if (quantity) quantity.value = String(Math.max(1, (parseInt(quantity.value, 10) || 1) - 1));
  });
  $('[data-quantity-plus]')?.addEventListener('click', () => {
    if (quantity) quantity.value = String((parseInt(quantity.value, 10) || 1) + 1);
  });
  $('[data-variant-select]')?.addEventListener('change', (event) => {
    const selected = event.target.selectedOptions[0];
    const price = $('[data-product-price]');
    const add = $('[data-add-to-cart]');
    if (price && selected) price.textContent = selected.dataset.price || '';
    if (add && selected) {
      add.disabled = selected.dataset.available !== 'true';
      add.firstChild.textContent = add.disabled ? 'Sold out ' : 'Add to cart ';
    }
  });
})();


const countryCurrencyPrefixes = {
  USD: "US",
  AUD: "AU",
  CAD: "CA",
  NZD: "NZ",
  SGD: "SG",
  HKD: "HK",
};

const activeCurrencyPrefix = countryCurrencyPrefixes[window.Shopify?.currency?.active];

const applyCountryCurrencyPrefix = (root = document) => {
  if (!activeCurrencyPrefix || !root) return;

  const textNodes = [];
  if (root.nodeType === Node.TEXT_NODE) {
    textNodes.push(root);
  } else {
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    while (walker.nextNode()) textNodes.push(walker.currentNode);
  }

  textNodes.forEach(node => {
    if (node.parentElement?.closest("script, style, noscript, textarea, option")) return;
    const currentValue = node.nodeValue || "";
    const prefixedValue = currentValue.replace(
      /(^|[\s(])\$(?=\d)/g,
      (match, leading) => leading + activeCurrencyPrefix + "$",
    );
    if (prefixedValue !== currentValue) node.nodeValue = prefixedValue;
  });
};

applyCountryCurrencyPrefix();

if (activeCurrencyPrefix && document.body) {
  const currencyPrefixObserver = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
      if (mutation.type === "characterData") {
        applyCountryCurrencyPrefix(mutation.target);
        return;
      }
      mutation.addedNodes.forEach(applyCountryCurrencyPrefix);
    });
  });

  currencyPrefixObserver.observe(document.body, {
    childList: true,
    subtree: true,
    characterData: true,
  });
}
